import React, { useEffect } from 'react';
import Homepage from './components/Homepage';
import './App.css';

const App: React.FC = () => {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    // Dev: stale SW caches break lazy-loaded admin chunks (ChunkLoadError).
    if (process.env.NODE_ENV !== 'production') {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.unregister());
      });
      if ('caches' in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      }
      return;
    }

    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => console.log('SW registered:', registration))
        .catch((error) => console.log('SW registration failed:', error));
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Homepage />
    </div>
  );
};

export default App;
